/**
 * Résout l'identifiant de profil membre pour les appels API (assistance, cotisations, etc.).
 * Ordre aligné sur la page d'accueil membre : member en base, person, puis session.
 *
 * @param {object} [personalStats]
 * @param {object} [user]
 * @returns {string} id ou chaîne vide
 */
export function resolveMemberProfileId(personalStats, user) {
  return String(
    personalStats?.member_id ||
      personalStats?.person_id ||
      user?.member_id ||
      user?.person_id ||
      ''
  ).trim();
}

/**
 * Prochain id candidat (person_id / member_id / session) pour un second appel API si le premier ne renvoie rien.
 *
 * @param {object} [personalStats]
 * @param {object} [user]
 * @param {string} [usedId] id déjà essayé
 * @returns {string} un autre id, ou '' si absent
 */
export function resolveNextMemberProfileId(personalStats, user, usedId) {
  const u = String(usedId || '').trim();
  const next = [
    personalStats?.person_id,
    personalStats?.member_id,
    user?.person_id,
    user?.member_id,
  ]
    .map((x) => String(x || '').trim())
    .find((id) => id && id !== u);
  return next || '';
}
